import { RouteConfig } from 'vue-router';
import Form from '@/views/layout/Form.vue';
import i18n from '@/i18n';

const routes: Array<RouteConfig> = [
  {
    path: 'healthteam',
    name: 'healthteam',
    component: Form,
    redirect: { name: 'healthteam-list' },
    meta: {
      session: true,
    },
    children: [
      {
        path: 'list',
        name: 'healthteam-list',
        component: () => import('@/views/healthTeam/HealthTeamList.vue'),
        meta: {
          header: {
            label: () => i18n.t('title.list', [i18n.tc('healthteam.label', 2)]),
          },
        },
      },
      {
        path: 'create',
        name: 'healthteam-create',
        component: () => import('@/views/healthTeam/HealthTeamCreate.vue'),
        meta: {
          header: {
            route: { name: 'healthteam-list' },
            label: () =>
              i18n.t('title.create', [i18n.tc('healthteam.label', 2)]),
          },
        },
      },
      {
        path: 'edit/:id',
        name: 'healthteam-edit',
        component: () => import('@/views/healthTeam/HealthTeamEdit.vue'),
        meta: {
          header: {
            route: { name: 'healthteam-list' },
            label: () => i18n.t('title.edit', [i18n.tc('healthteam.label', 2)]),
          },
        },
      },
    ],
  },
];

export default routes;
